<script lang="ts">
	import DarkModeWatcher from '$lib/component/navigation/DarkModeWatcher.svelte';
	import '../app.css';
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();
</script>

{@render children?.()}
<footer></footer>

<DarkModeWatcher />
